import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ErrorInterceptor } from './errors/error.interceptor';
import { AuthHeaderInterceptor } from './http/auth-header.interceptor';
import { AuthService } from './auth/auth.service';
import { LocalStorageService } from './services/local-storage.service';
import { TokenStorageService } from './services/token-storage.service';
import { TokenService } from './services/token.service';
import { CookieService } from './services/cookie.service';
import { UserActivityService } from './services/user-activity.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    AuthService,
    LocalStorageService,
    TokenStorageService,
    TokenService,
    CookieService,
    UserActivityService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHeaderInterceptor,
      multi: true
    },
    
  ],
})
export class CoreModule {}
